import styled from "styled-components"

const StyledStepFourth = styled.div`
  .order-calendar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .order-courier-form__info {
      flex-basis: 414px;
      max-width: 414px;
    }
    .calendar-box {
      flex: 1;
      margin-left: 30px;
      position: relative;
      .react-calendar {
        button {
          border: none;
        }
        &__navigation {
          display: flex;
          justify-content: space-between;
          padding-bottom: 20px;
          &__arrow {
            padding: 0;
            [stroke] {
              transition: stroke 0.2s;
            }
            &:hover {
              [stroke] {
                stroke: #00fb6e;
              }
            }
            &:disabled {
              opacity: 0.5;
              pointer-events: none;
            }
          }
          &__label {
            &__labelText {
              font-size: 16px;
              letter-spacing: 1.4px;
              cursor: default;
              font-family: futura-pt-bold, sans-serif;
              font-weight: 700;
              text-transform: uppercase;
              color: #000;
            }
          }
        }
        &__month-view {
          &__weekdays {
            border-top: 2px solid #000;
            border-bottom: 2px solid #000;
            padding: 10px 0;
            &__weekday {
              font-family: futura-pt-bold, sans-serif;
              font-size: 16px;
              font-weight: 700;
              color: #000;
              text-align: center;
              &::first-letter {
                text-transform: uppercase;
              }
              abbr {
                text-decoration: none;
              }
            }
          }
          &__days {
            padding: 5px 0;
            &__day {
              padding: 4px 10px;
              margin: 6px 0;
              font-size: 16px;
              line-height: 21px;
              transition: 0.2s;
              &.react-calendar__tile--active {
                background-color: #000;
                color: #fff;
                font-family: futura-pt-bold, sans-serif;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 1000px) {
      .order-courier-form__info {
        flex-basis: 330px;
        max-width: 340px;
      }
    }
    @media screen and (max-width: 900px) {
      flex-flow: wrap;
      .order-courier-form__info {
        flex-basis: 100%;
        max-width: 100%;
      }
      .calendar-box {
        flex-basis: 100%;
        max-width: 100%;
        margin: 50px 0 0;
      }
    }
    @media screen and (max-width: 500px) {
      .calendar-box {
        .react-calendar {
          &__navigation {
            padding-bottom: 13px;
            &__arrow {
              svg {
                max-width: 15px;
              }
            }
            &__label {
              &__labelText {
                font-size: 12px;
                line-height: 16px;
              }
            }
          }
          &__month-view {
            &__weekdays {
              padding: 5px 0;
              &__weekday {
                font-size: 12px;
                line-height: 16px;
              }
            }
            &__days {
              padding: 5px 0;
              &__day {
                font-size: 12px;
                line-height: 16px;
              }
            }
          }
        }
      }
    }
  }
`

export default StyledStepFourth
